import React from "react";

const Footer = () => {
    return (

        <footer className="bg-black">
            <div className="w-full  h-10 flex items-center justify-center">
                <span className="text-sm sm:text-center text-white">© 2023 <a href="/" className="hover:underline">Terms & Conditions</a>. All Rights Reserved.
                </span>
            </div>
        </footer>

    )
}

export default Footer